import { SubdivisionUpdateDto } from '@vatos-pas/common';
import {
  BOARD_COST_FIELDS_DW,
  BOARD_COST_FIELDS_DWP,
  commonCostFields,
  parseNumberInput,
} from 'providers/dataProvider';
import { SubDivisionFormValues } from './useSubDivisionContainer';

/**
 * Builds the `subdivision` body of PATCH /subdivision/:id/with-supervisors
 * from the edit form. The form is initialised with the whole record, so the
 * submitted values also carry entity keys the route rejects (id, timestamps,
 * relations, phaseStructureType); only SubdivisionUpdateDto keys are picked.
 * The cost rules match what dataProvider.update('subdivision') applied before
 * the route existed: a subdivision only stores the costs of its own structure,
 * and none at all unless it overrides the region costs.
 */
export const toSubdivisionUpdate = (
  values: SubDivisionFormValues,
): SubdivisionUpdateDto => {
  const isDrywallAndPaint = values.phaseStructureType === 'DrywallAndPaint';
  const ownCostFields = [
    ...commonCostFields.filter(field => field !== 'repairsRate'),
    ...(isDrywallAndPaint ? BOARD_COST_FIELDS_DWP : BOARD_COST_FIELDS_DW),
  ];
  const otherCostFields = isDrywallAndPaint
    ? BOARD_COST_FIELDS_DW
    : BOARD_COST_FIELDS_DWP;

  const costs: Record<string, number | null> = {};
  ownCostFields.forEach(field => {
    costs[field] = values.overrideRegionCostPerBoard
      ? parseNumberInput(values[field])
      : null;
  });
  otherCostFields.forEach(field => {
    costs[field] = null;
  });

  return {
    name: values.name,
    address1: values.address1,
    address2: values.address2 || null,
    city: values.city,
    state: values.state,
    zip: values.zip,
    builderId: values.builderId,
    regionId: values.regionId,
    active: values.active,
    warrantyStatus: values.warrantyStatus,
    reqBumpoutTimesheet: values.reqBumpoutTimesheet,
    overrideRegionCostPerBoard: values.overrideRegionCostPerBoard,
    overrideType: values.overrideRegionCostPerBoard
      ? values.overrideType
      : null,
    geoDistanceTolerance: values.geoDistanceTolerance,
    allowPayoutAmountEditing: values.allowPayoutAmountEditing,
    ...costs,
  } as SubdivisionUpdateDto;
};
